'use client';

import { useProtectedWorkspace } from '@/providers/protected-workspace-boundary';

/**
 * True once the workspace boundary has confirmed this signed-in user as a
 * member of `orgSlug`: stronger than "signed in", so member-only queries never
 * run while membership is still being (re)confirmed (#6012 triage).
 */
export function useConfirmedWorkspaceMember(
  orgSlug: string | null | undefined
): boolean {
  return useProtectedWorkspace(orgSlug ?? '') !== null && Boolean(orgSlug);
}
